import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useFeatureIsOn } from 'src/common/growthbook';

export const useReprofilingUser = () => {
  const reprofilingUsersIsEnabled = useFeatureIsOn('reprofiling-users');

  const [isReprofilingModalOpen, setIsReprofilingModalOpen] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.hash === '#reprofiling') {
      setIsReprofilingModalOpen(true);
      navigate(location.pathname, { replace: true });
    }
  }, [location.hash, location.pathname, navigate]);

  // TODO: 27/06/2025 - @jonroosevelt - Remove this mock notification when the real one is implemented
  const REPROFILING_NOTIFICATION_MOCK = {
    _id: 'reprofiling-notification',
    id: 'reprofiling-notification',
    title: 'Update Your Profile',
    description:
      '<a href="#reprofiling">Help us personalize your learning experience by updating your profile preferences.</a>',
    read: false,
    created: new Date().toISOString(),
    createdAt: new Date().toISOString(),
    link: '#reprofiling',
    isSpecial: false,
    icon: 'default',
  };

  return {
    reprofilingUsersIsEnabled,
    reprofilingNotification: reprofilingUsersIsEnabled ? REPROFILING_NOTIFICATION_MOCK : undefined,
    isReprofilingModalOpen,
    setIsReprofilingModalOpen,
  };
};
